import React, { useState } from 'react';
import logo from '../logo.png';
import API_BASE_URL from '../config/api';

import collageBanner from '../assets/collage_banner.jpg';

const LoginPage = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  // Multi-society selection state
  const [pendingUser, setPendingUser] = useState(null);
  const [availableSocieties, setAvailableSocieties] = useState([]);
  const [selectedSocietyId, setSelectedSocietyId] = useState('');

  const completeLoginWithSociety = (userData, selectedSociety) => {
    const finalUserData = {
      ...userData,
      society: selectedSociety
    };
    localStorage.setItem('ips_auth_token', userData.token || localStorage.getItem('ips_auth_token'));
    if (rememberMe) {
      localStorage.setItem('ips_user', JSON.stringify(finalUserData));
    }
    onLoginSuccess(finalUserData);
  };

  const handleSelectSocietySubmit = (e) => {
    e.preventDefault();
    if (!selectedSocietyId) {
      setStatus({ type: 'error', message: 'Please select a society to proceed.' });
      return;
    }
    const chosenSociety = availableSocieties.find(s => s._id === selectedSocietyId);
    completeLoginWithSociety(pendingUser, chosenSociety);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', message: '' });

    if (!email.trim() || !password.trim()) {
      setStatus({ type: 'error', message: 'Please provide both Email ID and Password.' });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log('Login API Response:', data);

      if (!response.ok || !data.success) {
        setStatus({ type: 'error', message: data.message || 'Login failed. Please check your credentials.' });
      } else {
        const u = data.user;
        const societiesList = Array.isArray(u.societies) ? u.societies : (u.society ? [u.society] : []);

        // If user is Secretary and has multiple societies mapped, present society selection screen
        if ((u.role || '').toLowerCase() === 'secretary' && societiesList.length > 1) {
          setPendingUser({ ...u, token: data.token });
          setAvailableSocieties(societiesList);
          setSelectedSocietyId(societiesList[0]._id);
          setStatus({ type: 'info', message: 'Multiple societies found. Please select your active society.' });
        } else {
          setStatus({ type: 'success', message: 'Login successful!' });
          completeLoginWithSociety({ ...u, token: data.token }, u.society);
        }
      }
    } catch (err) {
      console.error('Login request error:', err);
      setStatus({ type: 'error', message: 'Unable to connect to backend server.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      {/* Centered Overlay Login Box */}
      <div className="login-container">
        <div className="login-form-box">
          <div className="login-header">
            <img src={logo} alt="IPS & COOP Logo" className="app-logo" />
            <h2>Cooperative Machinery Tracker v2.0</h2>
            <p>Enter your email and mobile number to access your account</p>
          </div>

          {status.message && (
            <div className={`alert-message ${status.type}`}>
              {status.message}
            </div>
          )}

          {pendingUser ? (
            <form onSubmit={handleSelectSocietySubmit}>
              <div className="form-group" style={{ marginBottom: '20px' }}>
                <label htmlFor="societySelect" style={{ fontWeight: '600', color: '#1e293b' }}>
                  Select Active Society ({availableSocieties.length} mapped)
                </label>
                <select
                  id="societySelect"
                  value={selectedSocietyId}
                  onChange={(e) => setSelectedSocietyId(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid #cbd5e1',
                    fontSize: '14px',
                    fontWeight: '500',
                    outline: 'none',
                    background: '#ffffff',
                    marginTop: '8px'
                  }}
                >
                  {availableSocieties.map(s => (
                    <option key={s._id} value={s._id}>
                      {s.SOCIETY || s.SocietyName} ({s.VILLAGE || 'N/A'})
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" className="submit-btn" style={{ flex: 1 }}>
                  Continue to Dashboard
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setPendingUser(null);
                    setAvailableSocieties([]);
                    setStatus({ type: '', message: '' });
                  }}
                  style={{
                    background: '#f1f5f9',
                    color: '#475569',
                    border: '1px solid #cbd5e1',
                    borderRadius: '8px',
                    padding: '10px 16px',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Back
                </button>
              </div>
            </form>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email ID (Login ID)</label>
                <input
                  type="email"
                  id="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Mobile Number (Password)</label>
                <input
                  type="password"
                  id="password"
                  placeholder="Enter mobile number"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </div>

              <div className="form-actions">
                <label className="remember-me">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    disabled={loading}
                  />
                  Remember me
                </label>
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? 'Signing In...' : 'Sign In'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
